<template>
  <div class="realStatus" :style="{width:(statusDuration?70:30)+'px', borderColor: color[realTimeStatus] }">
    <p :style="{ background: color[realTimeStatus] }">{{
      carStatue[realTimeStatus]
    }}</p>
    <p v-show="statusDuration" class="realDuration">{{ utils.changeTime(statusDuration) }}</p>
  </div>
  
</template>
<script>
export default {
  props: ["realTimeStatus", "statusDuration"],
  data() {
    return {
      carStatue: {
        1: "离线",
        2: "停车",
        3: "行驶",
        4: "停留",
        5: "维修",
        6: "报废",
        7: "在线",//人员的
      },
      color: {
        1: "#838383",
        2: "#eb8c39",
        3: "#20be36",
        4: "#3a99ed",
        5: "#ff2727",
        6: "#515151",
        7: "#20be36",//人员
      },
    };
  },
  methods: {
    //utils.changeTime(locateData.statusDuration)
  }
};
</script>
<style lang="">
.realStatus {
  border:solid 1px;
  border-color:red;
  display:flex;
  line-height:16px;
  border-radius: 4px;
  width:30px;
  height:18px;
  
}
.realStatus p:first-child {
  color: #fff;
  font-size: 11px !important;

  border-radius: 4px;
  background: #1379ee;
  width:30px;
  text-align:center;
}
.realStatus p:last-child {
  font-size: 11px !important;
  color:#111;
  width:40px;
  padding-left:2px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/carStatue.vue